import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import HeaderBar from 'components/organisms/Bars/HeaderBar/HeaderBar';

const StyledQueryBar = styled(HeaderBar)`
  &.QueryBar {
    height: unset;
    max-height: min(${props => props.theme.layout(480)}, 60vh);
    overflow-y: auto !important;
    justify-content: space-between;
    background-color: ${props => props.theme.property('palette.primary.states.selected')};
    border-bottom: 1px solid ${props => props.theme.property('palette.divider')};

    .PageBar-toolbar {
      display: none;
    }
  }
  
  .QueryBar {
    &-content {
      display: flex;
      width: 100%;
      flex-grow: 1;
      margin-left: 0;
      min-height: fit-content;
      padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(3)};
    }
    
    &-query {
      display: flex;
      width: 100%;
      flex-grow: 1;
      max-height: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      row-gap: ${props => props.theme.layout('2sp')};
    }
  }

  &.QueryBar-type-assistant {
    .QueryBar {
      &-content {
        justify-content: center;
        min-height: ${props => props.theme.layout('21sp')};
      }
      
      &-query {
        max-width: ${props => props.theme.layout(912)};
      }
    }
  }
  
  &:not(.QueryBar-initialised) {
    border-bottom: unset;
    .QueryBar-content {
      display: none;
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .QueryBar {
      &-content {
        padding: ${props => props.theme.spacing(2)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledQueryBar.propTypes = {
  theme: PropTypes.object
};

export default StyledQueryBar;
